import { ServiceStatus } from './types';

export const renderServiceStatus = (
  status?: ServiceStatus,
): { color: string; text: string } => {
  if (status === 'assigned') {
    return {
      color: 'blue',
      text: 'Asignado',
    };
  }

  if (status === 'confirmed') {
    return {
      color: 'gold',
      text: 'Confirmado',
    };
  }

  if (status === 'cancelled') {
    return {
      color: 'volcano',
      text: 'Anulado',
    };
  }

  if (status === 'closed') {
    return {
      color: 'green',
      text: 'Finalizado',
    };
  }

  if (status === 'vehicle_on_departure_spot') {
    return {
      color: 'yellow',
      text: 'Vehículo en origen',
    };
  }

  if (status === 'ongoing') {
    return {
      color: 'green',
      text: 'En marcha',
    };
  }

  if (status === 'vehicle_on_arrival_spot') {
    return {
      color: 'green',
      text: 'Vehículo en destino',
    };
  }

  return {
    color: 'grey',
    text: 'Desconocido',
  };
};
